import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import facilityService from '../../../services/apiServices/facilityService';
import { PhysicianActions } from 'src/redux/actions/constant';
import physicianService from 'src/services/apiServices/physician-service/physician-service';
// import physicianService from 'src/services/apiServices/physician-service/physician-service';

const {
  GET_ALL_FACILITY_REQUEST,
  GET_ALL_FACILITY_SUCCESS,
  GET_ALL_FACILITY_LOADER,
  GET_ALL_FACILITY_FAILURE,
  GET_ALL_FACILITY_RESET,
} = PhysicianActions;

function* getFacility(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_ALL_FACILITY_LOADER });
    const response = yield call(physicianService.getAllFacility, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_ALL_FACILITY_SUCCESS, payload: response });
    } else {
      throw { ...response.data, statusCode: response?.status };
    }
  } catch (error) {
    yield put({ type: GET_ALL_FACILITY_FAILURE, payload: error });
  }
}

function* getFacilitySaga() {
  yield takeEvery(GET_ALL_FACILITY_REQUEST, getFacility);
}

export default getFacilitySaga;
